import consumer from "./consumer";
import sweet_alert from "../utilities/sweet_alert";

class SyncCompleteChannel {
  static init() {
    this.cable = consumer.subscriptions.create({ channel: 'SyncCompleteChannel', sync_enrollment_user: `sync_completed_job_${Traus.company.user.id}` }, {
      received: (data) => {
        console.log({ data })

        sweet_alert.fire({
          title: 'Pronto',
          icon: 'success',
          text: `Matrículas sincronizadas com o gateway de pagamento`,
          showClass: { backdrop: 'swal2-noanimation', popup: '', },
          hideClass: { popup: '' },
          customClass: {
            cancelButton: 'btn btn-gray-primary',
            confirmButton: 'btn btn-primary mr-3'
          },
          buttonsStyling: false,
          focusConfirm: true
        });
      }
    });
  }
}

$(() => SyncCompleteChannel.init());